import { RouteObject } from "react-router-dom";
import RequireActiveAccount from "../../components/router/require-active-account";
import { lazy } from "react";

const WalletHomeView = lazy(() => import("."));
const WalletReceiveView = lazy(() => import("./receive/index"));
const WalletReceiveTokenView = lazy(() => import("./receive/token"));
const WalletSendView = lazy(() => import("./send/index"));
const WalletSendCashuView = lazy(() => import("./send/cashu"));
const WalletSendTokenView = lazy(() => import("./send/token"));
const WalletPayLightning = lazy(() => import("./pay/lightning"));
const WalletReceiveLightning = lazy(() => import("./receive/lightning"));
const WalletSendOnchain = lazy(() => import("./send/onchain"));
const WalletReceiveOnchain = lazy(() => import("./receive/onchain"));
const WalletConvertView = lazy(() => import("./convert"));

export default [
  {
    index: true,
    element: (
      <RequireActiveAccount>
        <WalletHomeView />
      </RequireActiveAccount>
    ),
  },
  {
    path: "receive",
    children: [
      { index: true, Component: WalletReceiveView },
      { path: "token", Component: WalletReceiveTokenView },
      { path: "lightning", Component: WalletReceiveLightning },
      { path: "onchain", Component: WalletReceiveOnchain },
    ],
  },
  {
    path: "send",
    children: [
      { index: true, Component: WalletSendView },
      { path: "cashu", Component: WalletSendCashuView },
      { path: "token", Component: WalletSendTokenView },
      { path: "onchain", Component: WalletSendOnchain },
    ],
  },
  {
    path: "pay",
    children: [
      { path: "lightning", Component: WalletPayLightning },
    ],
  },
  { path: "convert", Component: WalletConvertView },
] satisfies RouteObject[];
